import coreAPI from 'apis/core';

export const getOrderStats = async ({ pharmacyId }) => {
  const stats = await coreAPI.order.getOrderStats({ pharmacyId });

  return stats;
};

export const putOrder = async ({ orderId, payload, params }) => {
  const response = await coreAPI.order.putOrder({ orderId, payload, params });

  return response;
};

export const getPatientPharmacyOrders = async (params) => {
  const response = await coreAPI.order.getOrders(params);

  return {
    orders: response.data,
    pagination: response.pagination,
  };
};

export const getOrdersForBatchToReady = async (params) => {
  const response = await coreAPI.order.getOrdersForBatchToReady(params);

  return {
    orders: response.data,
    pagination: response.pagination,
  };
};

export const batchMoveOrdersToReady = async ({ orderIds, pharmacyId, gpSentDaysAgo }) => {
  const response = await coreAPI.order.batchMoveOrdersToReady({
    orderIds,
    pharmacyId,
    gpSentDaysAgo,
  });

  return response.data[0];
};

export const getPrescriptionTemplatePDFUrl = async ({ orderId }) => {
  const response = await coreAPI.order.getPrescriptionTemplatePDF({ orderId });
  return response.data.template_url;
};

export const generateSignedPrescriptionPDFUrl = async ({ orderId, pin }) => {
  const response = await coreAPI.order.generateSignedPrescription({ orderId, pin });
  return response.data.templateUrl;
};

export const getGPLetterPDFUrl = async ({ orderId }) => {
  const response = await coreAPI.order.getGPLetterPDF({ orderId });

  return response.data.template_url;
};

export const reassignOrderPharmacy = async ({ orderId, pharmacyId }) => {
  const response = await coreAPI.order.reassignOrderPharmacy({ orderId, pharmacyId });

  return response.data[0];
};

export default {};
